$w.onReady( () => {
  $w("#dataset1").onReady( () => {

    $w("#repeater1").onItemReady( ($item, itemData, index) => {
      let theItem = itemData.episodeDescription;
      var shortDescription = theItem.substr(0,450);
      $item("#EpisodeDescription").text = shortDescription + "...";
    });

  } );
  
} );

export function loadingStrip_viewportEnter(event) {
$w("#loadingGif").show();  //This is your GIF or animated image
 $w("#dataset1").loadMore() //This is your dataset
  .then(() => {
   $w("#loadingGif").hide(); //This is your GIF or animated image

   console.log("Done loading more data");
  });}